
const Japan = {
    "form.isRequired": "{name}は必須項目です！",
    "form.OTPLabel": "メール認証コード",
    "form.OTPInputValidMessage": "成功しました",
    "form.OTPInputInvalidMessage": "認証コードが正しくありません",
    "form.OTPWaitSecondsLabel": "再送信 ({waitOtpSeconds}秒)",
    "form.OTPSendLabel": "認証コードを送信",
    "form.OTPSendSuccessLabel": "認証コードをメールに送信しました！",
    "form.OTPTips": "正しい認証コードを入力してください。",
    "form.selectInputLabel": "Search…",
    "form.uploadBtn": "アップロード",
    "form.uploadSizeTips": "ファイルサイズは5MB以下にしてください。",
    "form.uploadTypeTips": "対応ファイル形式：png gif jpg jpeg pdf",
    "form.uploadNumTips": "ファイルをアップロードしてください。",
    "form.isRequiredAccept": "続行するには同意が必要です。",
    "form.sendButton": "送信",
    "form.isEmail": "正しいメールアドレスを入力してください",
    "form.isSerialNumber": "{name}に13文字入力してください。",
    "form.categoryPlaceholder": "- 製品カテゴリを選択 -",
    "form.seriesPlaceholder": "- 製品シリーズを選択 -",
    "form.skuPlaceholder": "- 型番(SKU) -",
    "form.sendSuccessMsg": "送信完了！",

    "warrantyPeriod.checkTitle": "Check Warranty Period",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check the warranty period.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "Send Successfully! please check your email",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    Japan
}   